// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__A60n7","label":"SetPasswdForm_label__3VYqO"};